import React, { useEffect, useState } from 'react';
import { Menu, X, Code2 } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Portfolio',
    href: '#portfolio'
  }, {
    name: 'Testimonials',
    href: '#testimonials'
  }];
  return <header className={`sticky top-0 z-40 w-full transition-all duration-300 ${isScrolled ? 'bg-slate-900/95 backdrop-blur-md shadow-lg py-3' : 'bg-slate-900 py-5'}`} data-id="element-152">
      <div className="container mx-auto px-4 flex justify-between items-center" data-id="element-153">
        {/* Logo */}
        <a href="#" className="flex items-center gap-2 group" data-id="element-154">
          <div className="w-10 h-10 bg-red-600 rounded-lg flex items-center justify-center transform group-hover:rotate-12 transition-transform" data-id="element-155">
            <Code2 className="text-white w-6 h-6" data-id="element-156" />
          </div>
          <div className="flex flex-col" data-id="element-157">
            <span className="text-xl font-bold text-white leading-none" data-id="element-158">
              Hardy Blend
            </span>
            <span className="text-[10px] text-slate-400 tracking-wider uppercase" data-id="element-159">
              Web & App Dev
            </span>
          </div>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8" data-id="element-160">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-slate-300 hover:text-red-500 transition-colors relative group" data-id="element-161">
              {link.name}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-red-500 transition-all group-hover:w-full" data-id="element-162" />
            </a>)}
          <a href="#contact-form" className="px-5 py-2.5 bg-red-600 hover:bg-red-700 text-white text-sm font-bold rounded-full transition-colors shadow-lg shadow-red-900/20" data-id="element-163">
            Get Started
          </a>
        </nav>

        {/* Mobile Menu Button */}
        <button className="lg:hidden text-white p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-164">
          {isMobileMenuOpen ? <X data-id="element-165" /> : <Menu data-id="element-166" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-167">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden bg-slate-800 border-t border-slate-700 overflow-hidden" data-id="element-168">
            <div className="container mx-auto px-4 py-4 flex flex-col gap-4" data-id="element-169">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-slate-300 hover:text-red-500 font-medium py-2 border-b border-slate-700/50" data-id="element-170">
                  {link.name}
                </a>)}
              <a href="#contact-form" onClick={() => setIsMobileMenuOpen(false)} className="bg-red-600 text-white text-center py-3 rounded-lg font-bold mt-2" data-id="element-171">
                Get Started
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}